module.exports = __webpack_public_path__ + "img/mpCorte.a4b47a99.jpg";